import {alert} from '../../lib/utils'
export default {
  data() {
    return {
      confirmer: null
    }
  },
  methods: {
    alert,
    confirm(message, callback, options) {
      const closeIt = () => this.confirmer = null
      const defaultOptions = {
        title: null,
        message: 'Do you want to continue?',
        confirmLabel: 'Yes',
        denyLabel: 'No'
      }
      options = options || {}
      if (message) {
        options = _.isObject(message) ? message : {message}
      }
      options = _.merge({}, defaultOptions, options)
      let {confirmed = null, denied = null} = options
      options.confirmed = () => {
        if (callback) {
          callback()
        }
        if (confirmed) {
          confirmed()
        }
        closeIt()
      }
      options.denied = () => {
        if (denied) {
          denied()
        }
        closeIt()
      }
      this.confirmer = _.cloneDeep(options)
    }
  },

}

